import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AnalyticsService } from '@sm360/widget-commons-general';
import { Vehicle, VehicleConstants } from '@sm360/widget-commons-vehicle';
import { ConfigsService, LocaleService } from '@sm360/widget-commons-core-services';

import axios from 'axios';

function HocWithAnalytics(WrappedComponent) {
    class withAnalytics extends Component {
        constructor(props) {
            super(props);

            this.state = {
                trackingExecuted: false,
            };
            this.executeTracking = this.executeTracking.bind(this);
        }

        componentDidMount() {
            this.executeTracking(this.props.vehicle, this.props.purchaseMethods);
        }

        componentWillReceiveProps(nextProps) {
            this.executeTracking(nextProps.vehicle, nextProps.purchaseMethods);
        }

        getVehicleConditionLabel(vehicleConditionType) {
            switch (vehicleConditionType) {
                case VehicleConstants.VEHICLE_CONDITION.NEW:
                    return 'new';
                case VehicleConstants.VEHICLE_CONDITION.USED:
                    return 'used';
                case VehicleConstants.VEHICLE_CONDITION.DEMO:
                    return 'demo';
                case VehicleConstants.VEHICLE_CONDITION.CERTIFIED:
                    return 'certified';
                default:
                    return 'n/a';
            }
        }

        pushToDataLayer(vehicle, purchaseMethods = {}) {
            const vehicleAnalytics = {
                bodyStyle: vehicle.bodyStyle?.name,
                bodyStyleCode: '',
                bodyColour: null,
                exteriorColourStatus: 0,
                boxSizeCode: '',
                boxSize: '',
                cabSizeCode: '',
                cabSize: '',
                catalogVehicleId: 0,
                clearance: vehicle.clearance,
                dateSold: vehicle.dateSold,
                discount: purchaseMethods?.cashPurchase?.incentives?.total,
                doors: vehicle.doors,
                driveTrain: vehicle?.driveTrain?.name,
                driveTrainCode: vehicle?.driveTrain?.id,
                engine: vehicle.engine?.name,
                exteriorColour: vehicle?.exteriorColor?.colorDescription,
                favorite: false,
                fuelCity: vehicle.getConsumptionInCity(),
                fuelHighway: vehicle.getConsumptionOnHighway(),
                fuelType: vehicle?.fuel?.slug,
                id: `${vehicle?.vehicleId}`,
                interiorColour: vehicle?.interiorColor?.colorDescription,
                locked: vehicle.onHold,
                make: vehicle.getMake(),
                model: vehicle.getModel(),
                modelTrim: '',
                modelTrimCode: '',
                modelTrimStyle: [],
                newCarTrimId: 0,
                note: vehicle.description,
                odometer: vehicle.odometer,
                recentViewCount: vehicle.pageViewSummary?.recentViewCount,
                seating: vehicle.seating,
                sellingPrice: `${vehicle.salePrice}`,
                stockNumber: vehicle.stockNumber,
                sold: vehicle.isSold(),
                transmission: vehicle.getTransmission(),
                trim: vehicle.modelTrim?.name,
                vehicleId: vehicle.vehicleId,
                vin: vehicle.vin,
                year: `${vehicle.year}`,
                discontinued: vehicle.discontinued,
                online: vehicle.online,
                showroomVehicleId: vehicle.showroomVehicleId,
                stickerStatusOnOrder: false,
                stickerStatusInTransit: false,
                carId: `${vehicle.vehicleId}`,
                isDemo: vehicle.demo,
                stockNo: vehicle.stockNumber,
                vehicleCategory: 'car',
                isSold: vehicle.isSold(),
                hasVideo: !!vehicle.multimedia.hasVideo(),
                name: `${vehicle.year} ${vehicle.getMake()} ${vehicle.getModel()} (${vehicle.stockNumber})`,
                rebate: purchaseMethods?.cashPurchase?.incentives?.total,
                extColor: vehicle.exteriorColor.colorDescription,
                condition: this.getVehicleConditionLabel(vehicle.vehicleCondition),
                mileage: `${vehicle.odometer}`,
                isCertified: vehicle.certified,
                picturesCount: vehicle.multimedia?.pictures?.length,
                hasPictures: vehicle.multimedia?.hasPictures(),
                makeModel: `${vehicle.getMake()}/${vehicle.getModel()}`,
                hasGallery: vehicle.multimedia?.hasPictures(),
                category: 'car',
                isOnSpecial: purchaseMethods?.cashPurchase?.incentives?.total > 0,
                color: vehicle.exteriorColor?.colorDescription,
                salePrice: `${purchaseMethods?.cashPurchase?.sellingPrice}`,
                regularPrice: purchaseMethods?.cashPurchase?.retailDetails?.msrp,
                tagline: vehicle.tagline,
                isNew: vehicle.getIsVehicleNew(),
            };

            AnalyticsService.pushToDataLayer('inventory-detail', vehicleAnalytics);
        }

        buildAdacadoPixelTag(vehicle) {
            const { year, vin } = vehicle;

            const adacadoUrl =
                `https://pixel.adacado.com/1000846?segment=vehicle&dealerid=${ConfigsService.getOrganizationUnitId()}` +
                `&make=${encodeURIComponent(vehicle.getMake())}&model=${encodeURIComponent(vehicle.getModel())}` +
                `&year=${encodeURIComponent(year)}&vin=${encodeURIComponent(vin)}` +
                `&language=${LocaleService.getSimpleLocale()}`;

            axios.get(adacadoUrl);
        }

        executeTracking(vehicle, purchaseMethods) {
            if (!vehicle || !vehicle.vehicleId || !purchaseMethods.transactionToken || this.state.trackingExecuted) {
                return;
            }
            this.pushToDataLayer(vehicle, purchaseMethods);
            this.buildAdacadoPixelTag(vehicle);
            this.setState({ trackingExecuted: true });
        }

        render() {
            return (
                <div>
                    <WrappedComponent {...this.props} />
                </div>
            );
        }
    }

    withAnalytics.defaultProps = {
        vehicle: null,
        purchaseMethods: {},
    };

    withAnalytics.propTypes = {
        purchaseMethods: PropTypes.object,
        vehicle: PropTypes.instanceOf(Vehicle.VehicleModelV25),
    };

    withAnalytics.displayName = 'withAnalytics';

    return withAnalytics;
}

HocWithAnalytics.displayName = 'HocWithAnalytics';

export default HocWithAnalytics;
